module.exports = __webpack_public_path__ + "static/media/Founders.c0e2bf16.png";